// extracted by mini-css-extract-plugin
export default {"move_wrapper":"Move_move_wrapper__khiL0","move_icon":"Move_move_icon__cudo2","disabled":"Move_disabled__OGa+t"};